<template>
  <div>
    <b-modal v-model="showModal"
      :title="textMessage"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      @hidden="resetForm"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      no-enforce-focus>
      <form autocomplete="off" @submit.prevent="submitForm" enctype="multipart/form-data">
        <div class="modal-body">
          <div class="row container-fluid">
            <div class="form-group col-md-12">
              <label for="course"><b>Curso&nbsp;<span class="asterisk">*</span></b></label>
              <!-- <b-form-select v-model="form.course_id" :options="courses"></b-form-select> -->
              <v-select v-model="form.coursename" :options="courses" class="my-custom-select" @input="getModules(form.coursename.value)" placeholder="Seleccione..."></v-select>
              <span v-if="courseValid" class="text-danger" style="font-size: 10px;"><b>El campo Curso es requerido.</b></span>
            </div>

            <div class="form-group col-md-12">
              <label for="course"><b>Módulo&nbsp;<span class="asterisk">*</span></b></label>
              <!-- <b-form-select v-model="form.module_id" :options="modules"></b-form-select> -->
              <v-select v-model="form.modulename" :options="modules" class="my-custom-select" @input="getModules(form.coursename.value)" placeholder="Seleccione..."></v-select>
              <span v-if="moduleValid" class="text-danger" style="font-size: 10px;"><b>El campo Módulo es requerido.</b></span>
            </div>

            <div class="form-group col-md-12">
              <label for="topic"><b>Tema&nbsp;<span class="asterisk">*</span></b></label>
              <input v-model="form.topic" type="text" class="form-control " id="topic" name="topic" placeholder="Tema">
              <span v-if="topicValid" class="text-danger" style="font-size: 10px;"><b>El campo Tema es requerido.</b></span>
            </div>

            <div class="form-group col-md-8">
              <label for=""><b>Imagen&nbsp;</b></label>
              <input @change="handleFileChange" type="file" class="form-control" id="image" name="image" accept="image/jpg">
            </div>

            <div class="form-group col-md-12">
              <label for=""><b>Descripción&nbsp;</b></label>
              <ckeditor ref="editor" v-model="form.description" :editor="editor" type="classic" :config="editorConfig"></ckeditor>
            </div>

            <input v-model="form.id" type="hidden" class="form-control" id="id" name="id">
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
            <button type="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i> Guardar</button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { ClassicEditor, editorConfig } from '../../../../ckeditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';

export default {
  components: {BModal, vSelect, 'ckeditor': CKEditor.component},
  props: ['id', 'showModal'],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig,
      name: 'ckeditor',
      form: {
        image: null,
        description: '',
      },
      courseValid: false,
      moduleValid: false,
      topicValid: false,
      loading: false,
      textMessage: 'Crear Tema',
      courses: [],
      modules: [],
      coursesSelect: null
    }
  },
  created() {
      this.getCourses()
  },
  methods:{
    handleFileChange(event) {
      // Capturar el archivo seleccionado y asignarlo a la propiedad del formulario
      this.form.image = event.target.files[0];
    },
    close(bvModalEvent) {
      this.textMessage = 'Crear Tema'
      this.$emit('update:showModal', false)
      this.$emit('getRecords')
    },
    cancel(bvModalEvent) {
      this.textMessage = 'Crear Tema'
      this.$emit('update:showModal', false)
    },
    resetForm() {
      // Este método se ejecutará cuando el modal se oculte
      this.form = {
        image: null,
        description: ''
      };
    },
    getCourses() {
      axios.get(`/administration/courses/topics/getCourses`)
        .then(response => {
          this.courses = response.data.data
        })
    },
    getModules(course_id) {
      // this.form.modulename = null;
      axios.get(`/administration/courses/topics/getModules/${course_id}`)
        .then(response => {
          if (this.coursesSelect === course_id) {
            this.modules = response.data.data;
          } else {
            this.form.modulename = null;
            this.modules = response.data.data;
            this.coursesSelect = course_id;  // Actualizar coursesSelect
          }
        })
    },
    getRecord() {
      this.loading = true
      if(this.id) {
        axios.get(`/administration/courses/topics/${this.id}`)
        .then(response => {
            this.textMessage = 'Editar Tema'
            this.form.id = response.data.id
            this.form.topic = response.data.topic
            this.form.description = response.data.description

            this.form.coursename = {
              value: response.data.coursename.value,
              label: response.data.coursename.label
            };

            this.coursesSelect = response.data.coursename.value

            this.form.modulename = {
              value: response.data.modulename.value,
              label: response.data.modulename.label
            };
            // Llama a getModules con el ID del curso seleccionado al editar
            this.getModules(response.data.course_id);
            // console.log(response.data);
        })
        .finally(() => {
          this.loading = false
        })
      } else {
        this.form = {}
      }
    },
    submitForm() {
      this.loading = true;

      this.courseValid = false;
      this.moduleValid = false;
      this.topicValid = false;

      // Validar campos
      if (this.form.coursename == '' || this.form.coursename == null) {
        this.courseValid = true;
      }

      if (this.form.modulename == '' || this.form.modulename == null) {
        this.moduleValid = true;
      }

      if (this.form.topic == '' || this.form.topic == null) {
        this.topicValid = true;
      }

      // Si algún campo no es válido, detener el envío del formulario
      if (this.courseValid == true || this.moduleValid == true || this.topicValid == true) {
        return;
      }

      let formData = new FormData();

      // Verificar si this.id está definido
      if (this.id) {
        formData.append('id', this.form.id);
      } else {
        // Si this.id no está definido, asignar null a this.form.id
        this.form.id = null;
      }

      formData.append('coursename_id', this.form.coursename.value);
      formData.append('modulename_id', this.form.modulename.value);
      formData.append('topic', this.form.topic);
      formData.append('description', this.form.description);
      formData.append('image', this.form.image);


      // Validar tamaño y formato de la imagen
      // if (this.form.image) {
      //   const imageSizeLimit = 380 * 250; // Tamaño máximo permitido en píxeles
      //   const imageFile = this.form.image;

      //   if (imageFile.type !== 'image/jpeg') {
      //     toastr.error('La imagen debe estar en formato JPG.', 'Error', { icon: 'fa fa-times-circle' });
      //     this.loading = false;
      //     return;
      //   }

      //   const img = new Image();
      //   img.src = URL.createObjectURL(imageFile);

      //   img.onload = function () {
      //     const width = img.width;
      //     const height = img.height;

      //     if (width !== 380 || height !== 250) {
      //       toastr.error('La imagen debe tener un tamaño de 380x250 píxeles.', 'Error', { icon: 'fa fa-times-circle' });
      //       this.loading = false;
      //       return;
      //     }

      //     // Si la imagen cumple con los requisitos, continuar con el envío del formulario
      //     formData.append('image', this.form.image);

      //       // Envío del formulario
      //       this.sendForm(formData);

      //   }.bind(this);
      // } else {
      //   // Si no se proporciona una imagen, continuar con el envío del formulario
      //   formData.append('image', null);

      //   // Envío del formulario
        this.sendForm(formData);
      // }
    },

      // Función interna para enviar el formulario
      // const sendForm = () => {
      //   axios.post('/administration/courses/topics', formData, {
      //     headers: {
      //       'Content-Type': 'multipart/form-data',
      //     },
      //   })
      //   .then(response => {
      //     if (response.data.status == 'error') {
      //       toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
      //     } else {
      //       toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
      //     }
      //     this.close();
      //   })
      //   .catch(error => {
      //     console.error(error);
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
      // };
      sendForm(formData) {
      axios.post('/administration/courses/topics', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        if (response.data.status == 'error') {
          toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
        } else {
          toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
        }
        this.close();
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });
    },


    // submitForm() {
    //   console.log(this.form.coursename);
    //   this.loading = true
    //   let formData = new FormData();
    //   // Verificar si this.id está definido
    //   if (this.id) {
    //     formData.append('id', this.form.id);
    //   } else {
    //     // Si this.id no está definido, asignar null a this.form.id
    //     this.form.id = null;
    //   }
    //   formData.append('coursename_id', this.form.coursename.value);
    //   formData.append('modulename_id', this.form.modulename.value);
    //   formData.append('topic', this.form.topic);
    //   formData.append('description', this.form.description);
    //   formData.append('image', this.form.image);
    //   // axios.post('/administration/courses/topics', this.form)
    //   axios.post('/administration/courses/topics', formData, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data',
    //     },
    //   })
    //   .then(response => {
    //     if (response.data.status == 'error') {
    //       toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
    //     } else {
    //       toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
    //     }
    //     this.close();
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   })
    //   .finally(() => {
    //     this.loading = false;
    //   });
    // },
    filterOptions(options, search, label) {
      // Puedes personalizar la lógica de filtrado según tus necesidades
      return options.filter(option => option[label].toLowerCase().includes(search.toLowerCase()));
    },
  }
}
</script>

<style>
#__BVID__6___BV_modal_outer_ {
  /*z-index: 1000 !important;*/
  z-index: calc(var(--ck-z-panel) + 40) !important;
}
.ck-rounded-corners .ck.ck-balloon-panel {
  z-index: calc(var(--ck-z-panel) + 41) !important;
}
</style>